import axios from 'axios';

import { ApiError } from '@/api/http';
import { notifyApiError } from '@/hooks/useApiFeedback';
import i18n from '@/i18n';
import { getApiErrorMessage } from '@/utils/handleApiError';

function readHttpStatus(error: unknown): number | undefined {
  if (error instanceof ApiError) {
    return error.status;
  }
  if (axios.isAxiosError(error)) {
    return error.response?.status;
  }
  return undefined;
}

/** Status codes already surfaced by the axios response interceptor. */
function isQueryErrorHandledByInterceptor(error: unknown): boolean {
  const status = readHttpStatus(error);
  if (status === undefined) {
    return false;
  }
  return status === 401 || status === 403 || status >= 500;
}

export function notifyGlobalQueryError(error: unknown): void {
  if (isQueryErrorHandledByInterceptor(error)) {
    return;
  }

  notifyApiError(getApiErrorMessage(error, i18n.t('ERROR_MESSAGE')));
}
